export default function Footer() {
  const footerLinks = {
    platform: [
      { name: 'Ders Notları', href: '#ders-notlari' },
      { name: 'Online Deneme', href: '#online-deneme' },
      { name: 'Ödev Takibi', href: '#odev-takibi' },
      { name: 'AI Değerlendirme', href: '#ai-degerlendirme' },
    ],
    support: [
      { name: 'Yardım Merkezi', href: '#' },
      { name: 'SSS', href: '#' },
      { name: 'İletişim', href: '#iletisim' },
      { name: 'Geri Bildirim', href: '#iletisim' },
    ],
    legal: [
      { name: 'Gizlilik Politikası', href: '#' },
      { name: 'Kullanım Koşulları', href: '#' },
      { name: 'Çerez Politikası', href: '#' },
    ],
  };

  const socialLinks = [
    { icon: 'ri-facebook-fill', href: '#', color: 'hover:bg-blue-600' },
    { icon: 'ri-twitter-x-fill', href: 'https://x.com/AydosTolga86565', color: 'hover:bg-gray-900' },
    { icon: 'ri-instagram-fill', href: 'https://www.instagram.com/tolgaaydosegitimplatformu/', color: 'hover:bg-pink-600' },
    { icon: 'ri-youtube-fill', href: 'http://www.youtube.com/@TolgaAYDOS-w6s', color: 'hover:bg-red-600' },
    { icon: 'ri-linkedin-fill', href: '#', color: 'hover:bg-blue-700' },
  ];

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-emerald-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Top Section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/13efc658f5e4badd7f709164859f9a94/a99824fa5b58eead6e6c1148f2900914.jpeg" 
                alt="Tolga AYDOS Logo" 
                className="w-12 h-12 rounded-xl object-cover hover:scale-110 hover:rotate-6 transition-all duration-500 cursor-pointer animate-pulse"
              />
              <div>
                <h3 className="text-xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  Tolga AYDOS
                </h3>
                <p className="text-teal-100 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Fen Bilimleri Öğretmeni
                </p>
              </div>
            </div>
            <p className="text-teal-100 mb-6 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
              LGS'ye hazırlık sürecinde öğrencilerime en iyi eğitim deneyimini sunmak için tasarlanmış modern bir platform.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className={`w-10 h-10 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-lg ${social.color} transition-all duration-300 hover:scale-110 cursor-pointer`}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Platform Links */}
          <div>
            <h4 className="text-lg font-bold mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Platform
            </h4>
            <ul className="space-y-3">
              {footerLinks.platform.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-teal-100 hover:text-white transition-colors duration-300 cursor-pointer"
                    style={{ fontFamily: 'Poppins, sans-serif' }}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-lg font-bold mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Destek
            </h4>
            <ul className="space-y-3">
              {footerLinks.support.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-teal-100 hover:text-white transition-colors duration-300 cursor-pointer"
                    style={{ fontFamily: 'Poppins, sans-serif' }}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              İletişim
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <p className="text-teal-100" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    info@tolgaaydos.com
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <div>
                  <p className="text-teal-100" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    +90 (555) 123 45 67
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <div>
                  <p className="text-teal-100" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Tekirdağ, Türkiye
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 mb-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-teal-100 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
            © 2025 Tolga AYDOS. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-6">
            {footerLinks.legal.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="text-teal-100 hover:text-white text-sm transition-colors duration-300 cursor-pointer"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                {link.name}
              </a>
            ))}
          </div>
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-teal-100 hover:text-white text-sm transition-colors duration-300 cursor-pointer"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
